import React from 'react';
import { useTranslation } from 'react-i18next';
import { Constants } from '@pwc/pwc-deals-web-common';
import DisplayPill from './DisplayPill';

export const USER_VIEW_STATUS = {
  NONE: { displayName: 'pills.none', value: 0 },
  NEW: { displayName: 'pills.new', value: 1 },
  UPDATED: { displayName: 'pills.updated', value: 2 },
};

const UserViewStatusPill = ({ userViewStatus }) => {
  const { t } = useTranslation();
  const getUserViewStatusI18N = (_userViewStatus) =>
    Object.values(USER_VIEW_STATUS).find(
      (status) => status.value === _userViewStatus
    )?.displayName ?? '';
  return userViewStatus > Constants.USER_VIEW_STATUS.NONE.value ? (
    <DisplayPill dataTestId="user-view-status-pill" forUserView>
      {t(getUserViewStatusI18N(userViewStatus))}
    </DisplayPill>
  ) : null;
};

export default UserViewStatusPill;
